export default __webpack_public_path__ + "static/media/bannerTablet.08a57093.jpg";